import { Badge, Center, DataList } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaRegCopy } from "react-icons/fa6";
import { IoCheckmarkDoneOutline } from "react-icons/io5";

export const NGeniusCallback = () => {
  const location = useLocation();
  const [data, setData] = useState([]);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const reference = queryParams.get("ref");
    let status;

    if (location.pathname.includes("payment-success")) {
      status = "Success";
    } else if (location.pathname.includes("payment-cancel")) {
      status = "Failed";
    }

    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(reference);
        setCopied(true);
        setTimeout(() => setCopied(false), 1000);
      } catch (err) {
        console.error("Failed to copy:", err);
      }
    };

    setData([
      {
        label: "Status",
        value: (
          <Badge colorPalette={status === "Success" ? "green" : "red"}>
            {status}
          </Badge>
        ),
      },
      {
        label: "Ref ID",
        value: (
          <Badge
            cursor="pointer"
            display="flex"
            alignItems="center"
            gap="2"
            onClick={handleCopy}
            colorPalette="blue"
          >
            {copied ? <IoCheckmarkDoneOutline /> : <FaRegCopy />}
            {reference}
          </Badge>
        ),
      },
    ]);

    const timer = setTimeout(() => {
      window.close();
    }, 5000);
  
    return () => clearTimeout(timer);
  }, [location, copied]);

  return (
    <Center>
      <DataList.Root orientation="horizontal" divideY="1px" maxW="md">
        {data.map((item) => (
          <DataList.Item key={item.label} pt="4">
            <DataList.ItemLabel>{item.label}</DataList.ItemLabel>
            <DataList.ItemValue>{item.value}</DataList.ItemValue>
          </DataList.Item>
        ))}
      </DataList.Root>
    </Center>
  );
};
